import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from "./cx.js";
export function Mark({ tone = "accent", ruled = false, text = "footnote", className, children }) {
    return _jsx("span", { className: cx("mk", `mk-${tone}`, ruled && "mk-ruled", text, className), children: children });
}
export function Note({ tone = "quiet", role, className, children }) {
    return (_jsx("p", { role: role, className: cx("note", `note-${tone}`, "subhead", className), children: children }));
}
//# sourceMappingURL=Mark.js.map